// extracted by mini-css-extract-plugin
export default {"container":"docs_container__7sBeW","heavy":"docs_heavy__wOHmt"};